import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import BsPeopleFill from '@meronex/icons/bs/BsPeopleFill';
import IosArrowUp from '@meronex/icons/ios/IosArrowUp';
import VscCallOutgoing from '@meronex/icons/vsc/VscCallOutgoing';
import BiSupport from '@meronex/icons/bi/BiSupport';
import FaWhatsapp from '@meronex/icons/fa/FaWhatsapp';
import { useHistory, useLocation } from 'react-router-dom';
import { getFont, updateCartCount } from '../../../helpers';
import { getConfig } from '../../../utils/config';
import { isRewardsVisible } from '../../../utils/routing';
import { useDispatch, useSelector } from 'react-redux';
import CartModal from '../../Organisms/CartModal';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { dealAction } from '../../../store/deal-slice';

export const ChatbotFloater = () => {
    const [isVisible, setIsVisible] = useState(false);

    const toggleSection = () => {
        setIsVisible(!isVisible);
    };

    useEffect(() => {
        const handleScroll = () => {
            if (isVisible) {
                setIsVisible(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [isVisible]);

    const config = getConfig();
    return ReactDOM.createPortal(
        <div className="fixed bottom-4 right-6">
            <div className="flex flex-row-reverse lg:flex-row">
                <div
                    className={`bg-primary px-3 items-center  rounded-xl relative mr-2 lg:ml-2 transition-opacity duration-500 ease-in-out ${
                        isVisible
                            ? 'flex opacity-100'
                            : 'opacity-0 lg:opacity-100 max-w-full '
                    } flex`}
                >
                    <p className="text-white text-[15px] px-2 leading-[1]">
                        Happy to Help you
                    </p>
                    <div className=" text-[50px] leading-[0.2] text-primary absolute -right-3 top-1/2 -translate-y-1/2 rotate-0 opacity-0 lg:opacity-100">
                        ‣
                    </div>
                    <div className=" text-[50px] leading-[0] text-primary absolute -right-3 top-1/2 opacity-100 lg:opacity-0">
                        ‣
                    </div>
                </div>
                <div
                    className={`rounded-full flex items-center justify-center p-[18px] drop-shadow-2xl  shadow-2xl bg-primary h-14 w-14  md:mx-auto z-40 cursor-pointer`}
                    onClick={toggleSection}
                >
                    <BiSupport className=" text-white h-7 w-7 " />
                </div>
                <div
                    className={`rounded-full flex items-center justify-center p-[18px] drop-shadow-2xl shadow-2xl bg-primary h-14 w-14  md:mx-auto z-40 cursor-pointer `}
                    onClick={toggleSection}
                >
                    <BiSupport className=" text-white h-7 w-7 " />
                </div>
            </div>

            <div
                className={`py-4 px-6 bg-white rounded-lg mt-2 drop-shadow-xl overflow-hidden transition-max-height duration-500 ease-in-out ${
                    isVisible ? 'max-h-96' : 'max-h-0 mt-0 py-0'
                }`}
            >
                <a
                    href={`https://wa.me/+91${window.reloy_env.client_config.CONTACT_DETAILS?.WHATSAPP_CHATBOT}`}
                    target="_blank"
                >
                    <div className="flex justify-between items-center border-b-2 border-gray-200 pb-2 hover:text-primary">
                        <div>
                            <p className="text-sm text-gray-400">WhatsApp</p>
                            <h2 className="font-bold">
                                +91{' '}
                                {
                                    window.reloy_env.client_config
                                        .CONTACT_DETAILS?.WHATSAPP_CHATBOT
                                }
                            </h2>
                        </div>
                        <FaWhatsapp className="text-[#25d366] h-6 w-6" />
                    </div>
                </a>

                <a
                    href={`tel:${window.reloy_env.client_config.CONTACT_DETAILS?.MOBILE}`}
                >
                    <div className="flex justify-between items-center pt-2 hover:text-primary">
                        <div>
                            <p className="text-sm text-gray-400">Call Us</p>
                            <h2 className="font-bold ">{`+91 ${window.reloy_env.client_config.CONTACT_DETAILS?.MOBILE}`}</h2>
                        </div>
                        <VscCallOutgoing className="text-primary h-6 w-6" />
                    </div>
                </a>
            </div>
        </div>,
        document.getElementById('floater')
    );
};

export const DiwaliOffer = () => {
    const config = getConfig();
    const history = useHistory();
    const location = useLocation();
    return ReactDOM.createPortal(
        <div
            onClick={() => {
                window?.webengage?.track('ReferralSection', {
                    From: 'Floater'
                });

                history.push({
                    pathname: '/gift-and-earn',
                    state: { scrollTo: 'referral_section' }
                });
            }}
            className={` text-white bg-primary  z-40 cursor-pointer w-28 md:w-32 lg:w-56 h-12 fixed bottom-32 hover:right-0 right-[-166px] transition duration-500 ease-in-out flex ${config?.floaterClass}`}
        >
            <div className=" h-full ">
                <BsPeopleFill
                    className={`h-full w-14 px-4 object-cover text-white`}
                />
            </div>
            <p
                className={`${
                    getFont((config?.name).toUpperCase()).heading
                } text-2xs lg:text-sm xl:text-base px-2 self-center `}
            >
                Start Referring Now
            </p>
        </div>,
        document.getElementById('diwali')
    );
};

export const ScrollToTop = () => {
    const [isVisible, setIsVisible] = useState(false);
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    useEffect(() => {
        const toggleVisibility = () => {
            if (window.pageYOffset > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);

        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    //scroll-to-top classes: fixed, bottom:0, right:0
    return (
        isVisible && (
            <div
                onClick={scrollToTop}
                className="rounded-full p-3 drop-shadow-2xl  shadow-2xl bg-black opacity-50 h-10 w-10 fixed bottom-3 right-6 md:mx-auto z-40 cursor-pointer hover:opacity-100 hover:bg-info"
            >
                <IosArrowUp className=" text-white z-50" />
            </div>
        )
    );
};

export const CallFloater = () => {
    const config = getConfig();
    const history = useHistory();
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const internalWebview = useSelector(
        (state) => state.webView.internalWebview
    );
    const isCartModalVisible = useSelector(
        (state) => state.deals.isCartModalVisible
    );
    const [CartCount, setCartCount] = useState(null);
    const [CartValue, setCartValue] = useState([]);
    const [openCartModal, setOpenCartModal] = useState(false);
    const location = useLocation();
    const [isCartVisible, setIsCartVisible] = useState(false);
    const theme = useTheme();

    const screenBelowLg = useMediaQuery(theme.breakpoints.down('lg'));
    useEffect(() => {
        const isRewardStore =
            location?.pathname?.toLowerCase()?.includes('rewardstore') ||
            location?.pathname?.toLowerCase()?.includes('checkout');
        setIsCartVisible(isRewardStore);
    }, [location.pathname]);

    return ReactDOM.createPortal(
        <div>
            {!isCartVisible && !internalWebview && (
                <a
                    href={`tel:${window.reloy_env.client_config.CONTACT_DETAILS?.MOBILE}`}
                >
                    <div
                        className={`md:hidden h-[55px] flex items-center rounded-full justify-items-center bg-primary`}
                    >
                        <svg
                            className="m-auto"
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.072"
                            height="17.07"
                            viewBox="0 0 22.072 22.07"
                        >
                            <path
                                id="phone-incoming"
                                d="M20.944,16.71l3.242,1.934a1.841,1.841,0,0,1,.859,1.942,5.554,5.554,0,0,1-6.871,4.3A21.4,21.4,0,0,1,3.193,9.913,5.554,5.554,0,0,1,7.5,3.042h.02a1.841,1.841,0,0,1,1.947.868l1.919,3.239a2.517,2.517,0,0,1-.777,3.369L8.573,11.874a14.234,14.234,0,0,0,7.621,7.64l1.368-2.043a2.518,2.518,0,0,1,3.382-.761Z"
                                transform="translate(-3.008 -3.005)"
                                fill="#fff"
                            />
                        </svg>
                    </div>
                </a>
            )}
        </div>,
        document.getElementById('floater')
    );
};
export const CartFloater = () => {
    const config = getConfig();
    const dispatch = useDispatch();
    const history = useHistory();
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const isCartModalVisible = useSelector(
        (state) => state.deals.isCartModalVisible
    );
    const [CartCount, setCartCount] = useState(null);
    const [CartValue, setCartValue] = useState([]);
    const [openCartModal, setOpenCartModal] = useState(false);
    const location = useLocation();
    const [isCartVisible, setIsCartVisible] = useState(false);
    const theme = useTheme();

    const screenBelowLg = useMediaQuery(theme.breakpoints.down('lg'));
    useEffect(() => {
        // Visible only in rewards page
        const isRewardStore = location?.pathname
            ?.toLowerCase()
            ?.includes('rewardstore');
        setIsCartVisible(isRewardStore);
    }, [location.pathname]);

    useEffect(() => {
        // Initial count load

        // Listen for the custom 'cartUpdated' event

        window.addEventListener('cartUpdated', (event) => {
            updateCartCount(setCartCount, setCartValue);
            if (event?.detail?.showModal) {
                setOpenCartModal(true);
            }
           
        });
        // updateCartCount(setCartCount, setCartValue);
        // window.addEventListener('cartUpdated', () => {
        //     updateCartCount(setCartCount, setCartValue);
        // });

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('cartUpdated', () => {
                updateCartCount(setCartCount, setCartValue);
            });
        };
    }, []);

    const handleCartClick = () => {
        if (CartCount > 0) {
            dispatch(dealAction.setCartModalVisible(true));
            setOpenCartModal(true);

           
        } else {
            history.push('/rewardStore');
        }
    };

    return ReactDOM.createPortal(
        <>
            {isRewardsVisible &&
                isAuthenticated &&
                CartCount > 0 &&
                isCartVisible && (
                    // <div className=" block lg:hidden" >
                    <div
                        className={`block relative lg:hidden h-[60px] flex items-center justify-items-center rounded-full cursor-pointer mb-20  bg-primary`}
                        onClick={handleCartClick}
                    >
                        <svg
                            className="m-auto"
                            xmlns="http://www.w3.org/2000/svg"
                            width="22.427"
                            height="25.887"
                            viewBox="0 0 22.427 25.887"
                        >
                            <g id="bag" transform="translate(-3.005 -0.995)">
                                <path
                                    id="Path_7704"
                                    data-name="Path 7704"
                                    d="M25.427,21.792,23.864,6.771A2.583,2.583,0,0,0,21.291,4.45H18.444a4.314,4.314,0,0,0-8.455,0H7.142A2.581,2.581,0,0,0,4.57,6.77L3,21.792v.086a5.01,5.01,0,0,0,5,5H20.428a5.01,5.01,0,0,0,5-5A.767.767,0,0,0,25.427,21.792ZM14.217,2.725A2.593,2.593,0,0,1,16.657,4.45H11.776a2.593,2.593,0,0,1,2.441-1.726Zm6.212,22.432H8A3.279,3.279,0,0,1,4.726,21.92L6.286,6.952a.863.863,0,0,1,.856-.776H21.291a.863.863,0,0,1,.863.776L23.707,21.92a3.278,3.278,0,0,1-3.278,3.236Z"
                                    transform="translate(0 0)"
                                    fill="#fff"
                                />
                                <path
                                    id="Path_7705"
                                    data-name="Path 7705"
                                    d="M18.765,11a.863.863,0,0,0-.863.863,2.588,2.588,0,0,1-5.177,0,.863.863,0,1,0-1.726,0,4.314,4.314,0,0,0,8.628,0A.863.863,0,0,0,18.765,11Z"
                                    transform="translate(-1.097 -1.373)"
                                    fill="#fff"
                                />
                            </g>
                        </svg>
                        <span className="absolute w-[20px] h-[20px] border rounded-xl top-[15px] text-center bg-white right-[10px] text-xs font-medium">
                            {CartCount}
                        </span>
                    </div>
                    // </div>
                )}
            {openCartModal && isCartVisible && (
                <CartModal
                    openCartModal={openCartModal}
                    setOpenCartModal={setOpenCartModal}
                    cartValue={CartValue}
                    cartCount={CartCount}
                    setCartCount={setCartCount}
                    setCartValue={setCartValue}
                    screenBelowLg={screenBelowLg}
                ></CartModal>
            )}
        </>,
        document.getElementById('floater')
    );
};
